import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '../../shared/services/local-storage.service';
import { Router } from '@angular/router';
import { AuthService, UsersService } from 'src/app/api/identity/services';
import {
  LoginApiResponse,
  UserDto,
  UserProfileDto,
} from 'src/app/api/identity/models';
import { RedirectService } from 'src/app/shared/services/redirect-service';
import { UserGroupsService } from 'src/app/api/sms-app/services';
import { IParams } from 'src/app/shared/models/user.model';
import { CONSTANTS } from 'src/app/shared/models/constants';
import { UserGroupDto } from 'src/app/api/sms-app/models';

import {
  BrandingService,
  BrandProfile,
} from 'src/app/shared/branding/branding.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  // public auth!: Observable<any>;
  @HostBinding('class') class = 'w-100';
  public loginForm!: UntypedFormGroup;
  public isAuthLoading = false;
  userGroupOptions: UserDto[] = [];
  userParams: IParams = {
    page: 0,
    size: 20,
    userId: undefined,
  };
  constants = CONSTANTS;
  public loggedInUser: UserProfileDto = {};
  private isAdmin = false;
  private loginMessage = '';

  readonly brand: BrandProfile;

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private redirectService: RedirectService,
    private userGroupService: UserGroupsService,
    private userService: UsersService,
    branding: BrandingService
  ) {
    this.brand = branding.brand;
  }
  ngOnInit() {
    this.renderer.addClass(document.querySelector('app-root'), 'login-page');
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.required),
    });
  }

  loginByAuth() {
    if (this.loginForm.valid) {
      this.isAuthLoading = true;
      const payload = {
        body: {
          username: this.loginForm.value.email,
          password: this.loginForm.value.password,
        },
      };
      this.authService.passwordLogin(payload).subscribe(
        (res: LoginApiResponse) => {
          if (res.code === 200) {
            const token = res.data ? (res.data[0].accessToken as string) : '';
            const refresh = res.data
              ? (res.data[0].refreshToken as string)
              : '';

            this.localStorageService.setItem('token', token);
            this.localStorageService.setItem('refreshToken', refresh);

            this.fetchLoggedInUser();
            this.loginMessage = res.message || '';
          }
        },
        error => {
          this.isAuthLoading = false;
          this.loginForm.reset();
          error?.error?.message && this.toastr.error(error?.error?.message);
        }
      );
    } else {
      this.loginForm.markAllAsTouched();
      this.toastr.error('Credentials not found');
    }
  }
  fetchLoggedInUser() {
    this.userService.getLoggedInUserDetails().subscribe({
      next: user => {
        if (user?.data) {
          this.loggedInUser = user?.data[0] || {};

          this.redirectService.setPermissions(
            this.loggedInUser.Privileges || []
          );

          this.userParams.userId = this.loggedInUser?.id || undefined;
          this.isAdmin =
            this.loggedInUser.designation === CONSTANTS.ADMIN_DESIGNATION;

          this.fetchUserGroups(this.userParams, this.isAdmin);
          this.localStorageService.setItem(
            CONSTANTS.STORE_IS_ROLE_ADMIN,
            JSON.stringify(this.isAdmin)
          );
          this.localStorageService.setItem(
            CONSTANTS.STORE_USER_ID,
            JSON.stringify(this.loggedInUser.id)
          );
        }
      },
      error: error => {
        this.isAuthLoading = false;
        if (error.status !== 403) {
          this.toastr.error(error?.error?.message);
        }
      },
    });
  }

  fetchUserGroups(params: IParams, isAdmin: boolean) {
    this.userGroupService.getAllUserGroups(params).subscribe({
      next: response => {
        if (response?.data?.[0]) {
          this.userGroupOptions = response.data[0].data || [];
          if (this.userGroupOptions.length > 0 || isAdmin) {
            this.localStorageService.setItem(
              CONSTANTS.AUTHORIZATION,
              CONSTANTS.VIEW_SMS_APPLICATION
            );
            if (this.userGroupOptions) {
              this.localStorageService.setItem(
                CONSTANTS.USER_GROUP,
                JSON.stringify(
                  this.userGroupOptions.map((item: UserGroupDto) => item?.id)
                )
              );
            }
          }
          this.loginMessage && this.toastr.success(this.loginMessage);
          this.isAuthLoading = false;

          // Add a delay or use setTimeout if needed
          setTimeout(() => {
            const redirectUrl =
              this.redirectService.getRedirectUrl() || '/welcome';
            this.redirectService.clearRedirectUrl();
            this.router.navigate([redirectUrl]);
          }, 0);
        }
      },
      error: error => {
        this.isAuthLoading = false;
        console.log('error?.error?.message', error);
        // if (error.status == 403) {
        //   this.toastr.error(error?.error?.message);
        // }
        // Redirect anyway if user groups fails but login was successful
        setTimeout(() => {
          const redirectUrl = this.redirectService.getRedirectUrl() || '/sms';
          this.redirectService.clearRedirectUrl();
          this.router.navigate([redirectUrl]);
        }, 0);
      },
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.querySelector('app-root'), 'login-page');
  }
}
